// This button can't be implemented as Button from TDS
// because some browsers like Firefox don't allow to call file upload dialog
// programmatically. That's why we need to implement a button that looks like
// a button from TDS.

import * as React from "react";
import { style } from "typestyle";
import MapControl from "../components/atoms/MapControl";

interface IUploadButtonProps {
  onFileSelected: (fileContents: string) => void;
  onError: (errorMessage: string) => void;
  label: string;
}
const UploadButton = ({
  onFileSelected,
  label,
  onError,
}: IUploadButtonProps) => (
  <MapControl
    className={style({
      padding: "6px 10px",
    })}
  >
    <label
      className={style({
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      })}
    >
      <svg
        className={style({ marginRight: "4px" })}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16.5903 10H15.0003V15C15.0003 15.55 14.5503 16 14.0003 16H10.0003C9.45026 16 9.00026 15.55 9.00026 15V10H7.41026C6.52026 10 6.07026 8.92 6.70026 8.29L11.2903 3.7C11.6803 3.31 12.3103 3.31 12.7003 3.7L17.2903 8.29C17.9203 8.92 17.4803 10 16.5903 10Z"
          fill="black"
        />
        <path
          d="M5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z"
          fill="black"
        />
      </svg>
      <span>{label}</span>
      <input
        type="file"
        className={style({
          position: "absolute",
          top: 0,
          opacity: 0,
          width: "100%",
          height: "100%",
          visibility: "hidden",
        })}
        onChange={(e) => {
          const el = e.target;
          const { files } = el;
          if (!files) {
            return onError("No files provided");
          }
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            if (typeof fileReader.result === "string") {
              el.value = "";
              return onFileSelected(fileReader.result);
            }
            el.value = "";
            return onError("");
          };
          fileReader.readAsText(files[0]);
          return files;
        }}
      />
    </label>
  </MapControl>
);

export default UploadButton;
